import React, { useState } from 'react';
import '../css/Contacto.css';

import facebook from '../img/logos/facebookcirclegrande.png';
import instagram from '../img/logos/instagramcirclegrande.png';
import twitter from '../img/logos/twittercirclegrande.png';
import iconomapa from '../img/logos/iconomapa.png';
import youtubeicono from '../img/logos/youtubeicono.png';

function Contacto() {

    const direccion = "Gamero 2722";
    const telefono = "+56 2 2710 3043";
    const comuna = "Independencia";

    const [activeIcon, setActiveIcon] = useState(null);

    const handleIconClick = (icon) => {

        setActiveIcon(icon);

        window.setTimeout(() => {

            setActiveIcon(null);

        }, 700);

    };

    return (

        <section
            id="contacto"
            className="esc-contacto-section"
        >

            <div className="esc-contacto-container">

                <h2 className="esc-contacto-title">

                    Contacto

                </h2>

                <p className="esc-contacto-subtitle">

                    Estamos disponibles para atender tus consultas.
                    Puedes comunicarte con nosotros a través de los
                    siguientes medios.

                </p>


                {/* TARJETA DE CONTACTO */}

                <div className="esc-contacto-card">

                    <p>

                        <strong>📍 Dirección:</strong>

                        {" "}
                        {direccion}, {comuna}

                    </p>

                    <p>

                        <strong>☎ Teléfono:</strong>

                        {" "}
                        {telefono}

                    </p>

                    <p>

                        <strong>✉ Correo:</strong>

                        {" "}
                        escuela@nzelandia.cl

                    </p>

                </div>


                {/* BOTÓN MAPA */}

                <a
                    href="https://maps.app.goo.gl/d2wyMpzZ9RCua6TD8"
                    className="esc-contacto-mapa-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                >

                    Cómo llegar

                    <img
                        src={iconomapa}
                        alt="Mapa"
                        className="esc-contacto-map-icon"
                    />

                </a>


                {/* MAPA */}

                <div className="esc-contacto-mapa">

                    <iframe

                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1376.414367105761!2d-70.67253660743205!3d-33.4218996416447!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662c5fc29de65d7%3A0x3ca23f381c757a05!2sEscuela%20B%C3%A1sica%20Nueva%20Zelandia!5e1!3m2!1ses!2scl!4v1728910055776!5m2!1ses!2scl"

                        title="Mapa Escuela Nueva Zelandia"

                        loading="lazy"

                        allowFullScreen

                        referrerPolicy="no-referrer-when-downgrade"

                    />

                </div>


                {/* REDES */}

                <div className="esc-contacto-redes">

                    <h3>

                        Nuestras Redes Sociales

                    </h3>

                    <div className="esc-contacto-iconos">

                        <a

                            href="https://www.instagram.com/nuevazelandiaescuela"

                            target="_blank"

                            rel="noopener noreferrer"

                            onClick={() => handleIconClick('instagram')}

                        >

                            <img

                                src={instagram}

                                alt="Instagram"

                                className={`esc-contacto-icono ${activeIcon === 'instagram' ? 'esc-active' : ''}`}

                            />

                        </a>

                        <a

                            href="https://twitter.com/zelandia_nueva?lang=bg/"

                            target="_blank"

                            rel="noopener noreferrer"

                            onClick={() => handleIconClick('twitter')}

                        >

                            <img

                                src={twitter}

                                alt="Twitter"

                                className={`esc-contacto-icono ${activeIcon === 'twitter' ? 'esc-active' : ''}`}

                            />

                        </a>

                        <a

                            href="https://www.facebook.com/EscuelaNuevaZelancia"

                            target="_blank"

                            rel="noopener noreferrer"

                            onClick={() => handleIconClick('facebook')}

                        >

                            <img

                                src={facebook}

                                alt="Facebook"

                                className={`esc-contacto-icono ${activeIcon === 'facebook' ? 'esc-active' : ''}`}

                            />

                        </a>

                        <a

                            href="https://www.youtube.com/channel/UCv9kvVQXl1zXASkSQfra55w"

                            target="_blank"

                            rel="noopener noreferrer"

                            onClick={() => handleIconClick('youtube')}

                        >

                            <img

                                src={youtubeicono}

                                alt="YouTube"

                                className={`esc-contacto-icono ${activeIcon === 'youtube' ? 'esc-active' : ''}`}

                            />

                        </a>

                    </div>

                </div>

            </div>

        </section>

    );

}

export default Contacto;

